import React, { useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../../store/actions/data';

//Bootstrap
import { Container, Row, Col } from 'react-bootstrap';
import Products from '../../../components/Products/Products';
import ProductDetail from '../../../components/Products/ProductDetail/ProductDetail';

const Trabajos = (props) => {
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const posts = useSelector(state => state.data.posts);
    const typesPosts = useSelector(state => state.data.typesPosts);
    const postSelected = useSelector(state => state.data.postSelected);
    const postSelectedImages = useSelector(state => state.data.postSelectedImages);
    const relatedPosts = useSelector(state => state.data.relatedPosts);

    const fetchPost = useCallback(async (type) => {
        setError(null);
        try {
            if (props.match.params.titlesearch) {
                await dispatch(actions.fetchPostByTitle(props.match.params.titlesearch));
                await dispatch(actions.fetchPostImages(props.match.params.titlesearch));
            } else {
                await dispatch(actions.fetchPosts(type, 0));
            }
        } catch (err) {
            setError(err.message);
        }
    }, [dispatch, props.match.params.titlesearch]);

    const fetchPostsByType = useCallback(async (type, max) => {
        setError(null);
        try {
            await dispatch(actions.fetchPosts(type, 0));
        } catch (err) {
            setError(err.message);
        }
    }, [dispatch]);

    const fetchRelatedPosts = useCallback(async (type, max, id) => {
        setError(null);
        try {
            await dispatch(actions.fetchRelatedPosts(type, max, id));
        } catch (err) {
            setError(err.message);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchPost(0);
    }, [fetchPost, props.match.params.titlesearch]);

    useEffect(() => {
        if (postSelected) {
            fetchRelatedPosts(postSelected[0].ID_TIPO_POST, 3, postSelected[0].ID);
        }
    }, [postSelected, fetchRelatedPosts]);

    if (props.match.params.titlesearch && !error) {
        if (postSelected && postSelectedImages) {
            return (
                <ProductDetail
                    {...postSelected[0]}
                    images={postSelectedImages.length > 0 ? postSelectedImages : null}
                    relatedPosts={relatedPosts} />
            );
        }
    } else if (error) {
        return (
            <Container fluid className="p-5 text-center custom-text-black">
                <Row>
                    <Col>
                        <h1 className="font-weight-bolder mb-4">Oops</h1>
                        <h3 className="font-weight-lighter">Algo anda mal :(</h3>
                        <h3 className="font-weight-lighter">{error}</h3>
                    </Col>
                </Row>
            </Container>
        );
    }
    return (
        <React.Fragment>
            { !props.match.params.titlesearch && typesPosts && posts && !error ?
                <Products fromHome={false} productTypes={typesPosts} posts={posts} fetchPostsByType={fetchPostsByType} />
                :
                // <Container fluid className="p-5 text-center custom-text-black">
                //     <Row>
                //         <Col>
                //             <h1 className="font-weight-bolder mb-4">Oops</h1>
                //             <h3 className="font-weight-lighter">Algo anda mal :(</h3>
                //             <h3 className="font-weight-lighter">{error}</h3>
                //         </Col>
                //     </Row>
                // </Container>
                null
            }
        </React.Fragment>
    );
};

export const componentName = "Trabajos";
export default withRouter(Trabajos);